import { Call } from 'starknet';
import { MultiCallContract } from '../../services';
import { Decimal } from '../../datastructures';
import { MULTICALL_CONTRACT_ADDRESS, POOL_LP_TOKEN_DECIMALS } from '../../constants';
import { getConfigManager } from '../../config/getConfigManager';
import { walletAddressAtom } from '../wallet';
import { createAsyncAtom } from '../../lib/state';
import rpcProviderAtom from '../rpcProviderAtom';

const RESPONSE_CHUNK_SIZE = 3;

const poolBalanceAtom = createAsyncAtom(
  async get => {
    const provider = await get(rpcProviderAtom);
    const walletAddress = await get(walletAddressAtom);
    if (!walletAddress) {
      return {};
    }

    const pools = getConfigManager().getConfig().pools;

    const balances: { [pairId: string]: Decimal } = {};

    const calldata: Call[] = Object.entries(pools).map(([, poolConfig]) => ({
      contractAddress: poolConfig.pair.address,
      entrypoint: 'balanceOf',
      calldata: [walletAddress],
    }));

    const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

    const result = await multiCallContract.aggregate(calldata);
    if (!result) {
      return {};
    }

    for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
      const [, poolsConfig] = Object.entries(pools)[i / RESPONSE_CHUNK_SIZE];

      // Index 1,2 is balance
      const balance = new Decimal({ low: result[i + 1], high: result[i + 2] }, POOL_LP_TOKEN_DECIMALS);

      balances[poolsConfig.pair.id] = balance;
    }

    return balances;
  },
  undefined,
  ['pool-deposit', 'pool-withdraw', 'user-refresh'],
);
export default poolBalanceAtom;
